import { View, ViewOpts } from '@play-co/timestep-core/ui';
import { MagicLampsInfoBlock } from './MagicLampsInfoBlock';
import { MagicLampsLamp } from './MagicLampsLamp';
import { MagicLampsGenie } from './MagicLampsGenie';
import { MagicLampsGrandPrize } from './MagicLampsGrandPrize';
import { magicLampsGetGrandPrize } from 'src/replicant/match2/magiclamps/magiclamps.getters';

export class MagicLampsInfo extends View {
  private infos: MagicLampsInfoBlock[] = [];
  constructor(opts: ViewOpts) {
    super({
      canHandleEvents: false,
      ...opts,
    });

    this.infos.push(
      new MagicLampsInfoBlock({
        icon: new MagicLampsLamp({ scale: 0.75, y: 40 }),
        i18nKey: 'match2.magicLamps.info01',
        superview: this,
        x: 120,
        y: 340,
        visible: false,
      }),
    );

    this.infos.push(
      new MagicLampsInfoBlock({
        icon: new MagicLampsGenie({ scale: 0.75 }),
        i18nKey: 'match2.magicLamps.info02',
        superview: this,
        x: 120,
        y: 460,
        visible: false,
      }),
    );

    this.infos.push(
      new MagicLampsInfoBlock({
        icon: new MagicLampsGrandPrize({
          amount: magicLampsGetGrandPrize(),
          scale: 0.75,
        }),
        i18nKey: 'match2.magicLamps.info03',
        superview: this,
        x: 120,
        y: 750,
        visible: false,
      }),
    );
  }

  public async showAnimated() {
    for (const info of this.infos) {
      await info.showAnimated();
    }
  }

  public async hideAnimated() {
    for (const info of this.infos) {
      info.hideAnimated();
    }
  }
}
